import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import z from 'zod';

import { getTestProps } from '../../lib/helpers';

import { useAppForm } from '../../form-hooks/form';

const initialValues = { space: '' };

const ApiKeyAccessForm = ({ onSubmit, spaces, disabled, testId }) => {
  const { t } = useTranslation();

  const validationSchema = useMemo(
    () =>
      z.object({
        space: z.string().min(1, t('Form.FormErrorNotBlank')),
      }),
    [t],
  );

  const form = useAppForm({
    defaultValues: initialValues,
    onSubmit: onSubmit,
    validators: {
      onChange: validationSchema,
    },
  });

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      form.handleSubmit();
    },
    [form],
  );

  const spaceOptions = useMemo(
    () =>
      (spaces || []).map(({ id, name }) => ({
        value: id,
        label: name,
      })),
    [spaces],
  );

  return (
    <form.AppForm>
      <form
        id="access-keys"
        className="w-full"
        onSubmit={handleSubmit}
        noValidate={true}
      >
        <p className="my-4 text-center w-full">
          {t('ApiKeyAccess.SelectSpace')}
        </p>
        <form.AppField name="space">
          {(field) => (
            <field.Dropdown
              options={spaceOptions}
              placeholder={t('Spaces.SpaceSelector.PlaceHolder')}
              emptyOptions={
                <div className="py-2 px-4 dark:text-white">
                  {t('Spaces.SpaceSelector.EmptySpaces')}
                </div>
              }
              additionalClasses="max-w-sm mx-auto"
              additionalDropdownClasses="bottom-full top-auto mb-2 border"
              disabled={disabled}
              hideSearch
              {...getTestProps(testId, 'spaces', 'testId')}
            />
          )}
        </form.AppField>
      </form>
    </form.AppForm>
  );
};
export default ApiKeyAccessForm;
